function monthFormat(val) {
    let date = new Date(val)
    if (date.getMonth() + 1 < 10) return date.getDate() + '/' + '0' + `${date.getMonth()+1}` + '/' + date.getFullYear()
    return date.getDate() + '/' + date.getMonth() + 1 + '/' + date.getFullYear()
}
export { monthFormat }